// extracted by mini-css-extract-plugin
export var grayedOut = "RadioOption_grayedOut__lplVi";
export var label = "RadioOption_label__zB+o8";
export var md = "768px";
export var radioInput = "RadioOption_radioInput__HCmvG";
export var radioOptionWrapper = "RadioOption_radioOptionWrapper__IeGVq";
export var shared = "'../../../shared.module.css'";
export var subQuestion = "RadioOption_subQuestion__+BE4o";
export var textInput = "RadioOption_textInput__2jnF8";